import { useMutation } from '@tanstack/react-query';
import { throttle } from 'lodash';
import { useMemo } from 'react';

import { useHttpClient } from '@bonusly/http-client';

import { type TranscriptResponse } from '../lib/entities/speech-tags';

interface TranscriptBonusReasonParams {
	transcript_text: string;
	preview_mode?: boolean;
}

export const useTranscriptBonusReason = (options = {}) => {
	const http = useHttpClient('v2');

	const mutation = useMutation(
		async (params: TranscriptBonusReasonParams) => {
			const response = await http.post<TranscriptResponse>('/video/transcript_bonus_reason', {
				transcript_text: params.transcript_text,
				preview_mode: params.preview_mode,
			});
			return response.data;
		},
		{
			retry: false,
			...options,
		}
	);

	const throttledMutateAsync = useMemo(
		() =>
			throttle(async (params: TranscriptBonusReasonParams) => {
				if (params.preview_mode) {
					return await mutation.mutateAsync(params);
				}
				return null;
			}, 500),
		[mutation.mutateAsync]
	);

	return {
		mutation,
		throttledMutateAsync,
	};
};
